import { Box, Divider, styled } from "@mui/material";

export const styles = {
    navLeftBox: {
        display: {
            xs: 'none',
            sm: 'none',
            md: 'flex',
        },
        gap: 2,
    },
    navRightBox1: {
        display: { xs: 'none', sm: 'flex' },
        alignItems: 'center',
        gap: 2,
    },
    navRightBox2: {
        display: { xs: 'flex', sm: 'none' },
        flexDirection: 'column',
        gap: "4px",
        height: 24,
        mt: 1,
    }
}
export const Container = styled(Box)({
    height: '100vh',
    overflow: 'hidden',
});

export const Navbar = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingRight: '25px',
    paddingLeft: '30px',
    borderBottom: '1px solid #eee',
});

export const NavLeft = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
});

export const NavRight = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
});

export const Main = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'start',
    paddingTop: '40px',
    paddingBottom: '48px',
    paddingRight: '400px',
    paddingLeft: '48px',
    gap: '48px',
    backgroundColor: '#f9f9f9',
    height: 'calc(100vh - 64px)',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
     paddingRight: '48px',
    },
    [theme.breakpoints.down('sm')]: {
    gap: '0px',
    width: '100%',
    borderRadius: '0px',
    padding: theme.spacing(0)
  },
}))

export const Card = styled(Box)(({ theme }) => ({
    height: 421,
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '32px',
    borderRadius: '20px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: 630,
    borderRadius: '0px',
    padding: theme.spacing(0),
    paddingTop: theme.spacing(8)
},
}))

export const TabsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '20px',
    width: '100%',
});

export const TabBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
});

export const VerticalDivider = styled(Divider)({
    height: "40px",
    width: "2px",
    backgroundColor: "grey",
    border: "none",
    margin: "16px 0",
    opacity: 0.2,
});
